import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a9e2c97"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "px-3 py-2 items-center focus:outline-none text-xl flex",
  style: { width: '400px' }
}
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass('text-base whitespace-nowrap'),
  style: { width: '380px' }
}
const _hoisted_3 = {
  class: "fill-current",
  style: {"width":"20px"},
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "dropdown relative border-2 bg-gray-50 hover:border-primary-100 dark:bg-dark-400 dark:border-dark-400",
    style: {"border-radius":"0.5rem","width":"400px"},
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nested.hide.value = true)),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nested.hide.value = false))
  }, [
    _createElementVNode("button", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.itemList[_ctx.selectedIndex]), 1),
      (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", {
          class: _normalizeClass(["w-full border dark:border-dark-200 dropdown-menu absolute hidden shadow-xl z-10 overflow-y-scroll overflow-x-hidden", _ctx.isLightMode() ? 'custom-scrollbar' : 'custom-scrollbar-dark']),
          style: {"top":"2.6rem","max-height":"200px"}
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList, (value, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "rounded",
              style: { width: '394px' }
            }, [
              _createElementVNode("button", {
                class: "py-2 px-3 text-base w-full block whitespace-no-wrap text-left focus:outline-none bg-white hover:bg-primary-50 text-gray-800 dark:bg-dark-200 dark:text-dark-text dark:hover:bg-dark-10 dark:border-dark-200",
                onClick: ($event: any) => (_ctx.click(index))
              }, _toDisplayString(value), 9, _hoisted_6)
            ]))
          }), 128))
        ], 2), [
          [_vShow, !_ctx.nested.hide.value]
        ])
      ]),
      _: 1
    })
  ], 32))
}